import React from "react";
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import { 
  Stack, 
  TextField, 
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const EmployeeTypeForm = ({
  initialValues,
  onSubmit
}) => {
  let StatusSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });

  const hanldeSubmitFormik = (values) => {
    onSubmit(values);
  }

  const formik = useFormik({
    initialValues,
    validationSchema: StatusSchema,
    enableReinitialize: true,
    onSubmit: (values) => hanldeSubmitFormik(values)
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3} sx={{m: 2}}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="Name"
              {...getFieldProps('name')}
              error={Boolean(touched.name && errors.name)}
              helpertext={touched.name && errors.name}
            />
          </Stack>
        </Stack>
        <LoadingButton
          sx={{m: 2}}
          style={{display: "block"}}
          size="large"
          type="submit"
          variant="contained"
        >
          Submit
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
}

EmployeeTypeForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

EmployeeTypeForm.defaultProps = {
  initialValues: {
    name: "",
  },
  onSubmit: () => {}
};

export default EmployeeTypeForm;
